import { mapActions } from 'vuex';
import mixinAlert from '@/mixins/mixinAlert';

export default {
  mixins: [mixinAlert],
  data: () => ({
    filters: {},
    path: '',
    loading: false,
  }),
  methods: {
    clearField(key, submit= true) {
      if (typeof this.filters[key] == 'object') {
        this.filters[key] = {};
      }
      this.filters[key] = '';

      if (submit) {
        this.submitFilter();
      }
    },
    clearSelect(value)
    {
      if (!value) {
        this.submitFilter()
      }
    },
    clearFilterForm() {
      this.$refs.filterForm.reset();
      this.cleanupData();
      this.submitFilter();
    },
    cleanupData() {
      const keys = Object.keys(this.filters);
      keys.forEach((key) => {
        this.clearField(key, false);
      });
    },
    async prepareFilter() {
      let filter = {};
      filter.filterByColumnName = [];

      if (this.filters['PRODUCTPROP']) {
        if (/^\d+$/.test(this.filters['PRODUCTPROP'])) {
          this.filters['ITEM'] = this.filters['PRODUCTPROP'];
          this.filters['DESCRIPTION'] = '';
        } else {
          this.filters['DESCRIPTION'] = this.filters['PRODUCTPROP'];
          this.filters['ITEM'] = '';
        }
      }
      // eslint-disable-next-line no-unused-vars
      const { PRODUCTPROP, ...objFiltered } = this.filters;
      const data = Object.entries(objFiltered).reduce(
        (a, [k, v]) => (v ? ((a[k] = v), a) : a),
        {}
      );

      filter.filterByColumnName = data;

      return filter;
    },
    async submitFilter() {
      this.loading = true;

      if (this.cptdTotalFilters > 0 && !this.$refs.filterForm.validate()) {
        this.loading = false;
        return;
      }

      const filter = await this.prepareFilter();

      this.filters['DESCRIPTION'] = '';
      this.filters['ITEM'] = '';

      let result = await this.setDataToList(filter);
      this.loading = false;

      if (result instanceof Error) {
        await this.mixinAlertError();
      }
      return result;
    },
    ...mapActions({
      setDataToList(dispatch, payload) {
        return dispatch(this.getPathStore + '/setDataToList', payload);
      },
    }),
    updateQueryParams(params) {
      this.$route.query.page = 1;
      this.$router.push({
        query: {
          ...params,
        },
      });
    },
    updatePayloadWithQueryString() {
      const { query } = this.$route;
      const keys = Object.keys(this.filters);
      keys.forEach((key) => {
        this.filters[key] = query[key] || null;
      });
    },
    verifyNullableFilter(obj, strField, value) {
      if (value) {
        obj[strField] = value;
      }
    },
  },
  computed: {
    dateMustBeBiggerRule() {
      return (value) => {
        if (this.filters.DATE_BILLING_INICIAL) {
          const initialDate = this.$moment(this.filters.DATE_BILLING_INICIAL);
          const finalDate = this.$moment(value, 'DD/MM/YYYY');
          if (initialDate.diff(finalDate, 'days') > 0) {
            return this.$t('dateMustBeEqualOrGreaterThanInitial');
          }
          return true;
        } else {
          return true;
        }
      };
    },
    cptdTotalFilters() {
      return Object.keys(this.filters)
        .map((key) =>
          this.filters[key] &&
          ((typeof this.filters[key] === 'object' &&
            Object.keys(this.filters[key]).length !== 0) ||
            (this.filters[key] && this.filters[key].length))
            ? 1
            : 0
        )
        .reduce((a, b) => a + b);
    },
    getPathStore() {
      return `${this.path}Store`;
    },
  },
};
